import React from 'react';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import {Row, Col} from 'react-flexbox-grid/lib';
import { connect } from 'react-redux';
import {Card, CardHeader, CardMedia} from 'material-ui/Card';
import {List, ListItem} from 'material-ui/List';
import Divider from 'material-ui/Divider';
import {darkBlack} from 'material-ui/styles/colors';

import styles from './styles/PDOFDataStyles';
import SpinnerLoaderWithText from 'components/loaders/SpinnerLoaderWithText';
import {convertCmPerSecondToKmPerHour, convertCmPerSecondToMilePerHour, convertKmPerHourToMiPerHour, convertMiPerHourToKmPerHour} from 'services/systemOfUnitsServices';

class PDOFData extends React.Component {

    render() {
        console.info("pdof data rendered");

        const {translate, pdof, icnPlus, speedUnitOfMeasure, isMilesPerHour, isPdofSearching, isIcnPlusSearching} = this.props;

        var unitOfMeasure = translate('GLOBAL.miph');
        var deltaV;

        if(speedUnitOfMeasure && icnPlus)
        {
            deltaV = icnPlus.deltaV;

            switch(speedUnitOfMeasure)
            {
                case "cm/s":
                    if(isMilesPerHour)
                    {
                        unitOfMeasure = translate('GLOBAL.miph');
                        deltaV = parseFloat(convertCmPerSecondToMilePerHour(icnPlus.deltaV));
                    }
                    else{
                        unitOfMeasure = translate('GLOBAL.kmph');
                        deltaV = parseFloat(convertCmPerSecondToKmPerHour(icnPlus.deltaV));
                    }

                    break;
                case "km/h":
                    if(isMilesPerHour)
                    {
                        unitOfMeasure = translate('GLOBAL.miph');
                        deltaV = parseFloat(convertKmPerHourToMiPerHour(icnPlus.deltaV));
                    }
                    else{
                        unitOfMeasure = translate('GLOBAL.kmph');
                        deltaV = icnPlus.deltaV;
                    }
                    break;
                default:
                    /*
                        il dato originale è in miglia orarie
                        devo ottenere il corrispondente in km
                    */
                    if(isMilesPerHour)
                    {
                        unitOfMeasure = translate('GLOBAL.miph');
                        deltaV = icnPlus.deltaV;
                    }
                    else{
                        unitOfMeasure = translate('GLOBAL.kmph');
                        deltaV = parseFloat(convertMiPerHourToKmPerHour(icnPlus.deltaV));
                    }
                    break;
            }
        }

        return (
            <div style={styles.mainDataRow}>
                {
                    isIcnPlusSearching || isPdofSearching ? <SpinnerLoaderWithText />
                    :
                    <Card initiallyExpanded={true} >
                        <CardHeader title={translate('ICNPlusForm.pdofImage')} />
                        <Row>
                            <Col xs={12} sm={12} md={6} lg={4} >
                                <CardMedia expandable={true}  >
                                    {
                                        pdof ? <img src={`data:image/jpeg;base64,${pdof}`} alt="primary direction of force" /> : null
                                    }
                                </CardMedia>
                            </Col>
                            <Col xs={12} sm={12} md={6} lg={8} >
                                    {
                                        !icnPlus ? null :
                                        <List>
                                        <ListItem
                                            innerDivStyle={styles.listItemView}
                                            primaryText={
                                                <p style={styles.listItemViewParagraph}  >
                                                    <span style={{color: darkBlack}}>
                                                        {translate('DetailsPage.crashDirection')}:&nbsp;&nbsp;
                                                    </span>
                                                    {icnPlus.crashDirection}
                                                </p>
                                            }
                                        />
                                        <Divider/>
                                        <ListItem
                                            innerDivStyle={styles.listItemView}
                                            primaryText={
                                                <p style={styles.listItemViewParagraph}  >
                                                    <span style={{color: darkBlack}}>
                                                        {translate('ICNPlusForm.deltaV')}:&nbsp;&nbsp;
                                                    </span>
                                                    {
                                                        deltaV ?
                                                        <span>{deltaV.toFixed(2)}&nbsp;{unitOfMeasure}</span>
                                                        : null

                                                    }
                                                </p>
                                            }
                                        />
                                        <Divider/>
                                        <ListItem
                                            innerDivStyle={styles.listItemView}
                                            primaryText={
                                                <p style={styles.listItemViewParagraph}  >
                                                    <span style={{color: darkBlack}}>
                                                        {translate('GLOBAL.pdof')}:&nbsp;&nbsp;
                                                    </span>
                                                    {
                                                        icnPlus.pdof ?
                                                        <span>
                                                            {icnPlus.pdof.toFixed(1)}&nbsp;{translate('GLOBAL.degree')}
                                                        </span>
                                                        : null
                                                    }

                                                </p>
                                            }
                                        />
                                        <Divider/>
                                        <ListItem
                                            innerDivStyle={styles.listItemView}
                                            primaryText={
                                                <p style={styles.listItemViewParagraph}  >
                                                    <span style={{color: darkBlack}}>
                                                        {translate('ICNPlusForm.peakG')}:&nbsp;&nbsp;
                                                    </span>
                                                    {
                                                        icnPlus.peakG ?
                                                        <span>
                                                        {icnPlus.peakG.toFixed(1)}&nbsp;g
                                                        </span>
                                                        : null
                                                    }

                                                </p>
                                            }
                                        />
                                        <Divider/>
                                        <ListItem
                                            innerDivStyle={styles.listItemView}
                                            primaryText={
                                                <p style={styles.listItemViewParagraph}  >
                                                    <span style={{color: darkBlack}}>
                                                        {translate('ICNPlusForm.vehicleClass')}:&nbsp;&nbsp;
                                                    </span>
                                                    {icnPlus.vehicleClass}
                                                </p>
                                            }
                                        />
                                    </List>
                                    }
                            </Col>
                        </Row>

                    </Card>
                }

            </div>
        );
    }
}

PDOFData.propTypes = {
    //x: PropTypes.object,
    //x: PropTypes.func,
    //x: PropTypes.bool,
    //x: PropTypes.array.isRequired,
    //x: PropTypes.object.isRequired
}

function mapStateToProps(state, ownProps){
    return {
        translate: getTranslate(state.locale),
        currentLanguage: getActiveLanguage(state.locale).code,
        icnPlus: state.icnPlus.item,
        isIcnPlusSearching: state.icnPlus.isSearching,
        isMilesPerHour: state.systemUnitsSearch.item ? state.systemUnitsSearch.item.isMilesPerHour : false,
        speedUnitOfMeasure: state.systemUnitsSearch.item ? state.systemUnitsSearch.item.speedUnitOfMeasure : null,
        pdof: state.crashboxxPdof.binaries,
        isPdofSearching: state.crashboxxPdof.isSearching
    }
}
export default connect(mapStateToProps, null)(PDOFData);



// WEBPACK FOOTER //
// ./src/components/detailsPage/PDOFData.js